@use '../../../../../styles/Constants.scss' as Constants;

.notification-result {
	display: grid;
	grid-template-columns: max-content auto;
	column-gap: Constants.$val-spacing-m;
	margin-top: Constants.$val-spacing-s;
}

.notification-result-work-order-code {
	font-weight: bold;
}
